import { Component, EventEmitter, inject, Input, OnInit, Output, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatListModule } from '@angular/material/list';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { LicenseService } from '../../services/license.service';
import { delay } from 'utils-decorators';
import { cloneDeep, each } from 'lodash-es';

@Component({
  selector: 'app-module-list',
  standalone: true,
  imports: [
    MatButtonModule,
    FormlyModule,
    FormsModule,
    ReactiveFormsModule,
    MatListModule,
    MatCheckboxModule
  ],
  templateUrl: './module-list.component.html',
  styleUrl: './module-list.component.scss'
})
export class ModuleListComponent implements OnInit {
  @Output() moduleChangeEvent = new EventEmitter<{ module_key: string; description: string }[]>();
  private _selectedModules: { module_key: string; description: string }[] = [];
  @Input() set selectedModules(value: { module_key: string; description: string }[] ) {
    this._selectedModules = value || [];
    if (this.moduleList.length) {
      this.markSelected();
    }
  }

  moduleList: { module_key: string, description: string, checked?: boolean }[] = [];
  form = new FormGroup({});
  model: { module_key?: string, description?: string } = {};
  fields: FormlyFieldConfig[] = [
    {
      key: 'module_key',
      type: 'input',
      props: {
        label: 'Module key',
        placeholder: 'Enter Module key',
        required: true,
      }
    },
    {
      key: 'description',
      type: 'input',
      props: {
        label: 'Module description',
        placeholder: 'Enter module description',
        required: true,
      }
    },

  ];
  licenseService = inject(LicenseService);


  ngOnInit() {
    this.init();
  }

  init() {
    this.licenseService.getModule()
      .subscribe((res) => {
        this.moduleList = res.map((item: { module_key: string, description: string, checked?: boolean }) => {
          item.checked = this._selectedModules.some(sel => sel.module_key === item.module_key);
          return item;
        });
        this.updateModule();
      })
  }


  @delay(200)
  updateModule(item?: any, $event?: any) {
    if (item) {
      each(this.moduleList, (iter: any) => {
        if (iter.id === item.id) {
          item.checked = $event.checked
        }
      })
    }


    const modules = cloneDeep(this.moduleList).filter((item) => item.checked).map((item) => {
      delete item.checked;
      return item;
    })
    this.moduleChangeEvent.next(modules);
  }

  isAllSelected(): boolean {
    return this.moduleList.length > 0 && this.moduleList.every(item => item.checked);
  }

  isIndeterminate(): boolean {
    const checkedCount = this.moduleList.filter(item => item.checked).length;
    return checkedCount > 0 && checkedCount < this.moduleList.length;
  }

  toggleSelectAll($event: any): void {
    const isChecked = $event.checked;
    this.moduleList.forEach(item => {
      item.checked = isChecked;
    });
    this.updateModule();
  }

  private markSelected() {
    this.moduleList.forEach(item => {
      item.checked = this._selectedModules.some(sel => sel.module_key === item.module_key);
    });
    this.updateModule();
  }
}
